import { openDrawer, closeDrawer } from "@/src/components/dialogs";
import { ReferenceCategory, Reference } from "@/src/data/allTypes";
import { useState } from "react";
import { ReferenceChoiceList } from "./referenceChoiceList";

export function ReferencePicker({
  title,
  categories,
  current,
  onChange,
}: {
  title: string;
  categories: ReferenceCategory[];
  current: Reference | null | undefined;
  onChange: (newValue: Reference) => void;
}) {
  const [currentReference, setCurrentReference] = useState(current);
  return (
    <div
      className="field"
      onClick={async () => {
        await openDrawer({
          id: "referenceIdPicker",
          title: "Choisir une référence",
          content: (
            <ReferenceChoiceList
              categories={categories}
              current={[current]}
              onSelect={async (newValue) => {
                onChange(newValue);
                setCurrentReference(newValue);
                closeDrawer("referenceIdPicker");
              }}
            ></ReferenceChoiceList>
          ),
          footer: <div></div>,
        });
      }}
    >
      <div className="label">{title}</div>
      <div className="bold card">{currentReference?.name || "Non défini"}</div>
    </div>
  );
}
